import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const WarnIcon: FC<IconType> = ({ color = COLOR_BLACK }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
  >
    <path
      d="M13.826 10.8007L7.9613 1.044C7.75663 0.703333 7.3973 0.5 6.99996 0.5C6.60263 0.5 6.2433 0.703333 6.0393 1.04333L0.173964 10.8007C-0.0340363 11.1467 -0.0393697 11.5793 0.159297 11.9307C0.357297 12.282 0.731297 12.5 1.1353 12.5H12.8653C13.2686 12.5 13.6433 12.282 13.8413 11.9307C14.04 11.5793 14.034 11.1467 13.826 10.8007ZM7.3333 10.5H6.66663C6.48263 10.5 6.3333 10.3507 6.3333 10.1667V9.5C6.3333 9.316 6.48263 9.16667 6.66663 9.16667H7.3333C7.5173 9.16667 7.66663 9.316 7.66663 9.5V10.1667C7.66663 10.3507 7.5173 10.5 7.3333 10.5ZM6.99996 7.83333C6.63196 7.83333 6.3333 7.53467 6.3333 7.16667V5.16667C6.3333 4.79867 6.63196 4.5 6.99996 4.5C7.36796 4.5 7.66663 4.79867 7.66663 5.16667V7.16667C7.66663 7.53467 7.36796 7.83333 6.99996 7.83333Z"
      fill={color}
    />
  </svg>
);
